// extracted by mini-css-extract-plugin
module.exports = {"toggled-input":"ToggledInput_toggled-input__1X6XV"};